import { type GetStaticPaths, type GetStaticProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import { getLessonDetailsForSSR } from 'services/server/graphql/queries/getLessonDetailsForSSR';
import LessonPage from 'screens/LessonPage';
import { ServerProps } from 'screens/LessonPage/props';

const REVALIDATE_IN_SECONDS = 12 * 60 * 60 * 1;

const ExistingLessonPage: NextPage<ServerProps> = (props) => {
  const router = useRouter();
  const { query } = router;

  // Access query params to check if user needs to be navigate back to calendar or back
  const checkLessonQueryParam = query?.isNewLesson ? true : false;

  return (
    <LessonPage
      injectedLessonId={props.injectedLessonId}
      serverLessonData={props.serverLessonData}
      isNewLesson={false}
      handleBackNavigation={checkLessonQueryParam}
    />
  );
};

export const getStaticProps: GetStaticProps<ServerProps, { lessonId: string }> = async ({
  params,
}) => {
  const lessonId = params?.lessonId;

  if (!lessonId) {
    return {
      props: {
        injectedLessonId: '',
      },
      revalidate: REVALIDATE_IN_SECONDS,
    };
  }

  try {
    const { lessonsByPk } = await getLessonDetailsForSSR({ id: lessonId });

    return {
      props: {
        injectedLessonId: lessonId,
        serverLessonData: lessonsByPk,
      },
      revalidate: REVALIDATE_IN_SECONDS,
    };
  } catch (error) {
    // If lesson fetch fails, still return basic props
    console.error('Error fetching lesson for SSR:', error);
    return {
      props: {
        injectedLessonId: lessonId,
      },
      revalidate: REVALIDATE_IN_SECONDS,
    };
  }
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: true,
  };
};

export default ExistingLessonPage;
